import React, { useEffect, useState } from 'react'
import colors from 'theme/ui/colors'

const SECONDS_LIMITS = 60

const CircleProgressBar: React.FC<{
  triggerCallback: () => void
}> = ({ triggerCallback }) => {
  const [seconds, setSeconds] = useState(0)
  const radius = 8
  const circumference = 2 * Math.PI * radius
  const strokeDashoffset = circumference - (seconds / SECONDS_LIMITS) * circumference

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prev) => (prev + 1) % (SECONDS_LIMITS + 1))
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  useEffect(() => {
    if (seconds === SECONDS_LIMITS) {
      triggerCallback()
    }
  }, [seconds])

  return (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <circle cx="10" cy="10" r={radius} stroke={colors.textDisable} strokeWidth="4" fill="none" />

      <circle
        cx="10"
        cy="10"
        r={radius}
        stroke="#E960AF"
        strokeWidth="4"
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        transform="rotate(-90 10 10)" // Rotate to start from the top
      />
    </svg>
  )
}

export default CircleProgressBar
